export default "__VITE_ASSET__DRn2bfoB__"